import React from 'react'
import blob from '../assets/blob.svg'

export default function ServiceCard({title, description, link, icon = ""}){
  return (
    <div className="serviceCard">
      <div className="serviceCardImage" style={{display: "flex", alignItems: "center", justifyContent: "center", position: "relative"}}>
        <img src={blob} alt={title} />
        {icon !== "" && <img style={{position: "absolute", top: 0, left: 0, width: '40%', transform: 'translate(75%, 50%)', filter: "brightness(0) invert(1)"}} src={icon} alt={title} />}
      </div>
      <div className="serviceCardContent">
        <h1 className="serviceCardTitle">{title}</h1>
        <p className="serviceCardDescription">{description}</p>
        {/* <NavLink className="serviceCardLink" to={link}>Leer más</NavLink> */}
      </div>
    </div>
  )
}
